import { render, staticRenderFns } from "./card_articulo.vue?vue&type=template&id=2b62d008"
import script from "./card_articulo.vue?vue&type=script&lang=js"
export * from "./card_articulo.vue?vue&type=script&lang=js"
import style0 from "./card_articulo.vue?vue&type=style&index=0&id=2b62d008&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports